(() => {
  let lastFocusedElement: HTMLElement | null = null;

  /* Open dialog handler (event delegation) */
  document.addEventListener("click", (event: MouseEvent) => {
    const target = event.target as HTMLElement | null;
    if (!target) return;

    const openTrigger = target.closest<HTMLElement>("[data-dialog-open]");
    if (!openTrigger) return;

    const dialogId = openTrigger.dataset.dialogOpen;
    if (!dialogId) return;

    const dialog = document.getElementById(dialogId) as HTMLDialogElement | null;
    if (!dialog || typeof dialog.showModal !== "function") return;

    lastFocusedElement = document.activeElement as HTMLElement | null;

    mountDialogVideo(dialog);
    dialog.showModal();
  });

  /* Backdrop close */
  document.addEventListener("click", (event: MouseEvent) => {
    const target = event.target;
    if (!(target instanceof HTMLDialogElement)) return;
    if (!target.open) return;

    target.close("backdrop");
  });

  /* Close dialog event, Restore focus */
  document.addEventListener(
    "close",
    (event: Event) => {
      const dialog = event.target;
      if (!(dialog instanceof HTMLDialogElement)) return;

      lastFocusedElement?.focus();
      unmountDialogVideo(dialog);
    },
    true
  );

  /* Video funcitons */
  function mountDialogVideo(dialog: HTMLDialogElement): void {
    const videoId = dialog.getAttribute("data-video-id");
    if (!videoId) return;

    const content = dialog.querySelector<HTMLElement>("[data-dialog-video]");
    if (!content) return;

    content.innerHTML = `
      <iframe
        title="Video"
        src="https://player.cvm3.se/${encodeURIComponent(videoId)}?fetch=true"
        allow="autoplay"
        frameborder="0"
        allowfullscreen
      ></iframe>
    `;
  }

  function unmountDialogVideo(dialog: HTMLDialogElement): void {
    const videoId = dialog.getAttribute("data-video-id");
    if (!videoId) return;

    const content = dialog.querySelector<HTMLElement>("[data-dialog-video]");
    if (!content) return;

    content.innerHTML = "";
  }
})();
